import { type Conflict, type ReorderConflict } from '@editor2/types/conflict';
import { type CourseState } from '@editor2/types/courseState';

export class ElementItemMoveConflictResolver {
	acceptCurrent = (state: CourseState, conflict: Conflict | ReorderConflict) => {};

	acceptIncoming = (state: CourseState, conflict: Conflict | ReorderConflict) => {
		const { entityId, attribute, current, incoming } = conflict;

		const incomingParent = incoming as any;
		const currentParent = current as any;

		state.initialCourse.pages.entities[incomingParent.family_id].elements = incomingParent.elements;
		state.pages.entities[incomingParent.family_id][attribute] = incomingParent.elements;

		state.initialCourse.pages.entities[currentParent.family_id].elements =
			currentParent.elements.filter((id) => id !== entityId);
		state.pages.entities[currentParent.family_id][attribute] = currentParent.elements.filter(
			(id) => id !== entityId
		);
	};

	acceptBoth = (state: CourseState, conflict: Conflict | ReorderConflict) => {
		throw new Error('Accept both is not allowed for this type of conflict');
	};
}
